export interface LegalSection {
  title: string;
  content: string;
  id?: string;
}

export interface LegalDocument {
  title: string;
  lastUpdated: string;
  sections: LegalSection[];
}

export const PRIVACY_VERSION = '2026-03-26-ga4';
export const TERMS_VERSION = '2026-03-26-billing';
export const COOKIE_CONSENT_VERSION = '2026-03-26-ga4';
export const MARKETING_VERSION = '2026-03-26';

export type SupportedLocale = 'ko' | 'en' | 'ja' | 'zh-CN' | 'zh-TW';
